<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <Page>
        <PageBar direction="column">
            <Tab v-model="tabIndex">
                <TabPanel
                    v-for="item in tabList"
                    :key="item.id"
                    :sign="item.id"
                    :label="item.name"
                />
            </Tab>
        </PageBar>
        <LearningCodeList
            v-for="(item,key,index) in tabShowed"
            :key="`${key}:${index}`"
            v-show="tabKey === key"
            :code-status="key"
        />
    </Page>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import LearningCodeList from './_LearningCodeList';

const { mapGetters: mapGettersDic } = createNamespacedHelpers('Dictionary');
export default {
    name: 'LearningCodePage',
    components: { LearningCodeList },
    data() {
        return {
            tabKey_: this.$route.query.tabKey,
            tabShowed: {},
        };
    },
    computed: {
        ...mapGettersDic([
            'codeStatusList',
            'codeStatusMap',
            // add
        ]),
        tabList() {
            return [
                {
                    id: '',
                    name: '全部',
                },
                ...this.codeStatusList,
            ];
        },
        tabKey() {
            const { tabList, tabKey_ } = this;
            return `${tabKey_ || ''}` || `${(tabList[0] || {}).id || ''}`;
        },
        tabIndex: {
            get() {
                const { tabKey, tabList } = this;
                let index = -1;
                tabList.some((item, i) => {
                    const b = `${item.id}` === tabKey;
                    if (b) index = i;
                    return b;
                });
                return index < 0 ? 0 : index;
            },
            set(val) {
                const { tabList } = this;
                const tab = tabList[val];
                if (!tab) return;
                this.tabKey_ = tab.id;
                this.$router.replace({
                    ...this.$route,
                    query: {
                        ...this.$route.query,
                        tabKey: this.tabKey_,
                    },
                });
            },
        },
    },
    watch: {
        tabKey: {
            handler(val) {
                if (!this.$utils.isDef(val)) return;
                this.$set(this.tabShowed, val, true);
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss">
</style>
